import * as React from 'react';

function SvgPlayFilled(props) {
  return (
    <svg
      width="15"
      height="24"
      viewBox="0 0 15 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.600586 23.7529L14.793 12.1165L0.339437 0.905184L0.600586 23.7529Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgPlayFilled;
